import React from 'react'
import guideImg2_1 from '../../assets/images/sub/guide_img2_1.png'
import guideImg2_2 from '../../assets/images/sub/guide_img2_2.png'
import guideImg2_3 from '../../assets/images/sub/guide_img2_3.png'

import guideImgM2_1 from '../../assets/images/sub/guide_img2_1_m.png'
import guideImgM2_2 from '../../assets/images/sub/guide_img2_2_m.png'
import guideImgM2_3 from '../../assets/images/sub/guide_img2_3_m.png'

const GuideConfirm = (props) => {
  const mobileSelectBoxEvent = (e) => {
    e.preventDefault()
    e.preventDefault()
    e.target.classList.toggle('on')
  }

  return (
    <React.Fragment>
      <div className="guide-box gray mt0">
        <dl className="dlist3">
          <dt>전자문서지갑 안내</dt>
          <dd>
            종이증명서를 PC 또는 전자문서지갑 앱을 통해 전자증명서로 발급받아 열람하고 원하는 기관에 제출할 수 있는 유통수단 서비스입니다.
          </dd>
        </dl>
      </div>
      <ul className="nav-tab w200 mt40">
        <li>
          <button onClick={props.submitPage}>증명서 발급 · 제출 안내</button>
        </li>
        <li className="on">
          <button onClick={props.confirmPage}>증명서 진위확인 안내</button>
        </li>
      </ul>

      {/* mobile */}
      <div className="nav-wrap">
        <label className="current-menu2" onClick={mobileSelectBoxEvent}>
          증명서 진위확인 안내
        </label>
        <ul className="nav-menu">
          <li style={{ textAlign: 'center', marginBottom: '10px' }}>
            <label onClick={props.submitPage}>증명서 발급 · 제출 안내</label>
          </li>
          <li style={{ textAlign: 'center', marginTop: '10px' }} className="on">
            <label onClick={props.confirmPage}>증명서 진위확인 안내</label>
          </li>
        </ul>
      </div>
      <div className="cert-box mt30">
        <dl>
          <dt>증명서 진위확인 안내</dt>
          <dd>타임스캠프 및 블록체인 기술을 이용하여 전달받은 증명서에 대한 위변조 여부를 확인할 수 있는 서비스입니다.</dd>
        </dl>
      </div>
      <ul className="step-guide">
        <li>
          <div className="box">
            <dl>
              <dt>
                <span>STEP 1.</span> 진본검증이 필요한 문서 선택
              </dt>
              <dd>전자지갑을 통해 전달받은 문서 또는 확인이 필요한 문서를 업로드 합니다.</dd>
            </dl>
            <div className="thumb">
              <img src={guideImg2_1} alt="진본검증이 필요한 문서 선택" className="pc-only" />
              <img src={guideImgM2_1} alt="진본검증이 필요한 문서 선택" className="mobile-only" />
            </div>
          </div>
          <div className="box">
            <dl>
              <dt>
                <span>STEP 2.</span> 진본검증 진행하기
              </dt>
              <dd>[진본검증] 버튼을 클릭하여 진위확인을 진행을 합니다.</dd>
            </dl>
            <div className="thumb">
              <img src={guideImg2_2} alt="진본검증 진행하기" className="pc-only" />
              <img src={guideImgM2_2} alt="진본검증 진행하기" className="mobile-only" />
            </div>
          </div>
        </li>
        <li>
          <div className="box">
            <dl>
              <dt>
                <span>STEP 3.</span> 진본검증 결과 확인
              </dt>
              <dd>진위확인 결과를 확인합니다.</dd>
            </dl>
            <div className="thumb">
              <img src={guideImg2_3} alt="진본검증 결과 확인" className="pc-only" />
              <img src={guideImgM2_3} alt="진본검증 결과 확인" className="mobile-only" />
            </div>
          </div>
        </li>
      </ul>
    </React.Fragment>
  )
}

export default GuideConfirm
